(function() {
    'use strict';

    angular.module('swif.patrimoine')
        .controller('ContractTaskRecurrenteController', ContractTaskRecurrenteController);


    function ContractTaskRecurrenteController($scope, patrimoine, openstc, swif, swifOpenbaseCompanyService) {
        'ngInject';
        console.log('init ContractTaskRecurrenteController');
        var serviceInter = openstc;
        var service = patrimoine.contract;
        // for now, the model is an openstc.task.recurrence object
        $scope.callbackTask = service.callbackTask;
        $scope.fetchOccurrences = fetchOccurrences;
        $scope.notify = service.notify;

        swifOpenbaseCompanyService.getGlobalSettings().then(function(company) {
            $scope.taskNotify = company.task_notify;

            if ($scope.model.notify === undefined){
                $scope.model._recurrence.notify = company.task_notify_default_value;
            }
        });
        /*
         * in order to generate occurrences,
         * we save the current modale and then call genrate_dates() method
         * Finally, we fetch results to update the current occurrences
         */
        $scope.generateDates = generateDates;
        $scope.getSitesFilters = getSitesFilters;
        $scope.initialize = initialize;
        $scope.updateSiteControls = service.updateSiteControls;
        $scope.loading = service.recurrence.loading;

        if ($scope.model._defer) {
            $scope.model._defer.then(function() {
                // @tocheck: does this 2nd callback called AFTER the first one
                // (defined on service ?)
                $scope.initialize();
            });
        } else {
            $scope.initialize();
        }
        /* According to newV, oldV and initial name value, update the name
          - if no name was filled, set a value
        */
        $scope.$watch('model._recurrence.task_categ_id', watchTaskCategId);
        $scope.$watch('model._recurrence.site_ids', watchSiteIds);
        $scope.$watch('model._recurrence.occurrences.length', watchOccurrences);
        $scope.$watchGroup(
            ['model._recurrence.user_id', 'model._recurrence.service_id'],
            watchGroupUserOrService
        );

        function fetchOccurrences(recurrence) {
            var filter = {};
            swif.data.addFilter(filter, 'recurrence_id.id', '=', recurrence.id);
            swif.data.addFilter(filter, 'site_ids', '!=', false);
            swif.data.get('patrimoine_contract_task', undefined, filter)
                .then(function(data) {
                    recurrence.occurrences = data;
                    // swif.message.loading($scope.loading.tasks, 'ok');
                }, $scope.onError);
        }

        function generateDates() {
            service.recurrence.generateDates($scope.model._recurrence);
        }

        function getSitesFilters() {
            service.task.getSitesFilters(
                $scope.filters,
                $scope.model._recurrence
            );
        }

        function initialize() {
            // @tocheck: WARNING ! sometimes, $scope.model is not a contract but a task,
            // this is due to button displayed on tasks-table, where data.model is task

            _.defaults($scope.model._recurrence, {
                recur_length_type: 'until'
            });
            // if a control model is set on contract, retrieve default values from it
            if (!$scope.model._recurrence.id && $scope.model.control_type_id) {
                swif.data.get(
                    'patrimoine_control_type',
                    $scope.model.control_type_id[0]
                ).then(function(ret) {
                    $scope.model._controlModel = ret;
                    var defaultVals = _.omit(ret, 'id', 'name', 'is_official', 'is_erp', '_type', 'actions');
                    // complete defaultVals with some default initial values
                    _.merge($scope.model._recurrence, defaultVals);
                });
            }

            // finally, initilize filters for ui-select components
            $scope.filters = serviceInter.task.getFilters($scope.model._recurrence, undefined, true);
            if ($scope.model._recurrence.id) {
                // swif.message.loading($scope.loading.tasks);
                $scope.fetchOccurrences($scope.model._recurrence);
            }

            $scope.getSitesFilters();

            // initialize _siteControls internal hash
            var filter = {};
            var controlDefer;
            // if task already has some controls on database, initialize them
            if ($scope.model._recurrence.id) {
                swif.data.addFilter(
                    filter,
                    'task_recur_id',
                    '=',
                    $scope.model._recurrence.id
                );
                controlDefer = swif.data.get(
                    'patrimoine_site_control_tmpl',
                    undefined,
                    filter
                );
                // else, for new task, try to retrieve controls from its project
                // @notes: scope.model refers to the project on which we opened the modal
            } else if ($scope.model.id) {
                swif.data.addFilter(
                    filter,
                    'project_id',
                    '=',
                    $scope.model.id
                );
                controlDefer = swif.data.get(
                    'patrimoine_site_control_tmpl',
                    undefined,
                    filter
                );
            }
            if (controlDefer) {
                controlDefer.then(function(data) {
                    // set the _index attribute to correctly react on site_ids updates
                    _.forEach(data, function(item) {
                        // delete id because its only a copy from project controls
                        delete item.id;
                        if (item.site_id) {
                            item._index = item.site_id[0];
                        }
                        if (item.equipment_id) {
                            item._index = item.equipment_id[0];
                        }
                    });
                    $scope.model._recurrence._siteControls = data;
                });
            }
        }

        function watchGroupUserOrService(newV, oldV) {
            if (!angular.equals(newV, oldV)) {
                $scope.filters = serviceInter.task.getFilters($scope.model._recurrence, undefined, true);
            }
        }

        function watchTaskCategId(newV, oldV) {
            var newVal = newV ? newV[1] : '';
            var oldVal = oldV ? oldV[1] : '';
            var newString = $scope.model._recurrence.name;
            if (!$scope.model._recurrence.name) {
                newString = newVal;
            } else if (!angular.equals(newVal, oldVal) && oldVal === $scope.model._recurrence.name) {
                newString = newVal;
            }
            $scope.model._recurrence.name = newString;
        }

        function watchSiteIds(newV, oldV) {
            if (!angular.equals(newV, oldV)) {
                $scope.getSitesFilters();
                $scope.model._recurrence._siteControls = $scope.updateSiteControls(
                    $scope.model._recurrence._siteControls,
                    newV,
                    oldV,
                    'patrimoine_site'
                );
            }
        }

        function watchOccurrences(newV) {
            $scope.is_recurrence_valid = newV > 0;
        }
    }
})();
